import { Tabs } from '../../ds/components';
import styles from './DealsPage.module.css';

export type DealsTab = 'pipeline' | 'list' | 'invoicing' | 'commissions';

export const DEALS_TABS: readonly { value: DealsTab; label: string }[] = [
  { value: 'pipeline', label: 'Pipeline' },
  { value: 'list', label: 'Liste' },
  { value: 'invoicing', label: 'Abrechnung' },
  { value: 'commissions', label: 'Provisionen' },
];

export function isDealsTab(value: string | null): value is DealsTab {
  return DEALS_TABS.some((tab) => tab.value === value);
}

/** The tab bar under the head of Tools › Deals (Pipeline · Liste · Abrechnung · Provisionen). */
export function DealsTabs({ value, onChange }: { value: DealsTab; onChange: (tab: DealsTab) => void }) {
  return <Tabs label="Deals" items={DEALS_TABS} value={value} onChange={onChange} className={styles.tabs} />;
}
